import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Help } from 'app/shared/models/class/help/help';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HelpService {
  helps: Help[] = [];
  helpsListChanged = new Subject<Help[]>();
  private baseUrl: string = environment.apiUrl + '/HelpVideo';

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  gethelps(): Observable<Help[]> {
    return this.http.get<Help[]>(`${this.baseUrl}/Video`)
    .pipe(
      map(helps => {
        // this.helps = helps.map(p => any.fromObject(p));
        this.helps = helps.map(help => {
          if (help.videoName) {
            help.nbrVideos = 1;
          } else if (help.subVideoHelp?.length > 0) {
            help.nbrVideos = help.subVideoHelp.length;
          } else {
            help.nbrVideos = 0;
          }
          return help;
        })
        this.helpsListChanged.next([...this.helps]);
        return [...this.helps];
      })
    );
  }

  getHelpByKey(videoHelpKey: number) {
    return this.http.get<Help>(`${this.baseUrl}/Video/${videoHelpKey}`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */

  addHelp(help: any): Observable<any> {
    return this.http.post<Help>(`${this.baseUrl}/HelpVideo`, help);
  }

  uploadVideo(file: File) {
    const formData = new FormData();
    if (file) { formData.append('video', file, file.name); }

    return this.http.post(`${this.baseUrl}/UploadVideo`, formData);

  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  updateHelp(help: Help) {
    return this.http.put(`${this.baseUrl}/HelpVideo`, help);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     DELETE                                    */
  /* -------------------------------------------------------------------------- */

  delete(help: Help) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: help
    };


    return this.http.delete(`${this.baseUrl}/DeleteHelpVideo`, options);
  }

}
